import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollTo } from "../utils/smoothScroll";

// Resets scroll position to the top on every route change.
// Without this, Lenis retains the previous scroll offset, which made pages
// (e.g. legal pages opened from the footer) appear blank/broken.
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Reset native scroll immediately, then sync Lenis if available.
    window.scrollTo(0, 0);
    scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
};
